<template>
  <div class="tab-navigation tab-navigation--glass" role="tablist">
    <button
      v-for="tab in tabs"
      :key="tab.id"
      type="button"
      role="tab"
      class="tab-navigation__button"
      :class="{ active: modelValue === tab.id }"
      :aria-selected="modelValue === tab.id"
      @click="$emit('update:modelValue', tab.id)"
    >
      <span class="tab-navigation__label">{{ tab.name }}</span>
      <span
        v-if="tabCounts && tabCounts[tab.id] !== undefined"
        class="tab-count"
      >
        ({{ tabCounts[tab.id] }})
      </span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'TabNavigation',
  props: {
    tabs: {
      type: Array,
      required: true,
      validator: (value) => value.every((tab) => 'id' in tab && 'name' in tab),
    },
    modelValue: {
      type: String,
      required: true,
    },
    tabCounts: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['update:modelValue'],
};
</script>

<style src="./styles/TabNavigation.css" scoped></style>
